<template>
    <div class="media">
        <div class="media__card">
            <div class="media__card__video" v-if="video !== ''">
                <div v-html="video"></div>
            </div>
            <img v-else :src="img">
            <div class="media__card__button">
                <!-- <p class="button" @click="$emit('click_edit', this.p_id)">Bewerk</p> -->
                <p class="button_2" @click="$emit('click_del', this.p_id)">Verwijder</p>
            </div>
        </div>
        <p>{{ titel }}</p>
    </div>
</template>
<script>
export default {
    props:["projectID", "titel", "img", "video"],
    inject:["status"],
    data(){
        return{
            p_id: this.$props.projectID,
        }
    },
    methods:{
        edit(){
            let link = "/pages?page=projects&edit=true&id=" + this.p_id;
            this.status.pagesPage = "projects"
            this.$router.push(link)
        },
        del(){
            let link = "/pages?page=projects&delete=true&id=" + this.p_id;
            this.status.pagesPage = "projects"
            this.$router.push(link)
        }
    }
}
</script>